module.exports = __webpack_public_path__ + "static/media/logo-inverted.0df86dd5.svg";